import { Minus, Plus } from "lucide-react";
import { useState } from "react";

/**
 * Faith-neutral by construction (CLAUDE.md): the supplied prototype's first answer named a
 * specific faith institution ("community organizations, mosques, and nonprofits") — corrected
 * here to the same generic "houses of worship and community organizations" phrasing GH-890 used,
 * since outreach targeting a particular community is never reflected in this page's own words.
 */
const FAQS: readonly [question: string, answer: string][] = [
  [
    "Who is GiveHere for?",
    "GiveHere is designed for houses of worship and community organizations that bring people together to give. A demo is the best way to explore how it fits your events and day-to-day fundraising.",
  ],
  [
    "Do donors need to download an app?",
    "The giving experience is designed to open from a QR code or shared link, with a web experience alongside the iPhone app. We'll walk through the options available for your organization in the demo.",
  ],
  [
    "Can we use it on our existing website?",
    "The organizer tools include giving widgets, buttons, and shareable links designed to work with your existing website. You can see the setup and donor experience during a demo.",
  ],
  [
    "What about pledges and gifts made in person?",
    "The organizer experience keeps pledges and processing payments distinct from received funds. It also includes a workflow for verifying and recording cash and checks.",
  ],
  [
    "What will we cover in a demo?",
    "We'll walk through the donor experience, the live-event controls, and the tools for managing gifts. Bring your questions and tell us about your organization or next event.",
  ],
];

export function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="questions" className="section">
      <div className="page faq">
        <div className="faq__intro">
          <p className="overline">
            <span className="overline__rule" aria-hidden="true" />A few good questions
          </p>
          <h2>
            Let's make
            <br />
            <em>things clear.</em>
          </h2>
          <a className="faq__link" href="#demo">
            Talk to us about your organization
          </a>
        </div>
        <div className="faq__list">
          {FAQS.map(([question, answer], index) => (
            <div className="faq__item" key={question}>
              <h3>
                <button
                  className="faq__question"
                  aria-expanded={open === index}
                  aria-controls={`faq-answer-${index}`}
                  onClick={() => setOpen(open === index ? null : index)}
                >
                  {question}
                  {open === index ? <Minus size={18} /> : <Plus size={18} />}
                </button>
              </h3>
              <div className="faq__answer" id={`faq-answer-${index}`} hidden={open !== index}>
                <p>{answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
